import { css } from '@emotion/react';
import { useContext } from 'react';
import { Cell } from '@tanstack/react-table';
import { AngularContext } from 'react-app';
import type { RowProps } from 'shared/components/nv-table';
import ClickableContainer from 'components/clickable-container';
import { MentoringProgramGuide } from 'redux/schemas/models/mentoring-program-guides';
import { gray7 } from 'styles/global_defaults/colors';
import AppearsInCell from './appears-in-cell';
import AudienceCell from '../../audience-cell';
import OptionsCell from './options-cell';
import TitleCell from './title-cell';
import { config } from '@config/pendo.config.json';


export type CellProps = {
  className: string,
  cell: Cell<MentoringProgramGuide, any>;
};

const cellMap = {
  appears_in: AppearsInCell,
  title: TitleCell,
  audience: AudienceCell,
  options: OptionsCell,
};

const GuideRow = ({
  row,
  className,
  getCellStyle,
}: RowProps<MentoringProgramGuide>) => {
  const styles = css`
    height: 65px;

    &:hover {
      background-color: ${gray7};

      .options-target {
        opacity: 1;
      }
    }
  `;

  if (!row.original) {
    return null;
  }

  const { injectServices } = useContext(AngularContext);
  const [$state] = injectServices(['$state']);

  const handleRowClick = () => {
    const params = { guideId: row.original.id };
    $state.go($state.current, params, { notify: false });
  };

  return (
    <ClickableContainer
      css={styles}
      className={`align-content-center border-bottom border-gray-6 ${className}`}
      data-qa={`${config.pendo.athena.mentorshipProgram.guides.guideRow}_${row.original.id}`}
      onClick={handleRowClick}
    >
      {row.getVisibleCells().map((cell, index) => {
        const CellComponent = cellMap[cell.column.id];

        return (
          <CellComponent
            css={getCellStyle(index)}
            cell={cell}
            key={cell.id}
          />
        );
      })}
    </ClickableContainer>
  );
};

export default GuideRow;
